import React from 'react';
import ReactDOM from 'react-dom';
import { CampaignHealthStatus } from './CampaignHealthStatus';
export function CampaignHealthStatusPortal(param) {
    var campaignId = param.campaignId, _param_portalContainerIdPrefix = param.portalContainerIdPrefix, portalContainerIdPrefix = _param_portalContainerIdPrefix === void 0 ? 'ops' : _param_portalContainerIdPrefix;
    var element = document.getElementById("".concat(portalContainerIdPrefix, "-campaign-status-").concat(campaignId));
    var disabled = element.dataset.disabled === '1';
    return /*#__PURE__*/ ReactDOM.createPortal(/*#__PURE__*/ React.createElement(CampaignHealthStatus, {
        campaignId: campaignId,
        disabled: disabled,
        justifyContent: "center"
    }), element);
}
